// oxlint-disable-next-line import/default
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.mjs?url";
import { GlobalWorkerOptions } from "pdfjs-dist";

// Registers the pdf.js worker URL once. Imported for its side effect by every
// module that uses pdfjs-dist; kept out of src/index.tsx so the @pdf vendor
// chunk is only fetched when a pdf-consuming view loads.
if (typeof window !== "undefined" && "Worker" in window) {
    GlobalWorkerOptions.workerSrc = pdfjsWorker;
}
